import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'

function NumberField ({ field }) {
  const { formatter } = useFormattingContext()

  return (
    <Typography className='__tbp10' variant='h2'>{formatter(field.value, field?.data?.format || 'number')}</Typography>
  )
}

NumberField.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.any,
    data: PropTypes.shape({
      format: PropTypes.string
    })
  })
}

export default NumberField
